// @ts-check

import React from "react";
import { actions } from "actions";
import { connect } from "unistore/preact";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/bot/HoneyPot.scss';

/**
 * @template T
 * @typedef {import('preact').ComponentType<T>} ComponentType
 */

/**
 * @typedef {import('preact').JSX.Element} JSXElement
 * @typedef {import('preact').JSX.TargetedMouseEvent<HTMLButtonElement>} ButtonClickEvent
 *
 * @typedef {Object} HoneyPotProps
 * @property {() => void} onHPTriggered - Callback function triggered when the honeypot is activated.
 */

/**
 * HoneyPot component renders a hidden button intended to detect bot interactions.
 * When the button is clicked, it triggers the provided onHPTriggered callback.
 *
 * @param {HoneyPotProps} props - The props for the HoneyPot component.
 * @returns {JSXElement} The rendered HoneyPot component.
 */
const HoneyPot = ({ onHPTriggered }) => {
  /** @param {ButtonClickEvent} event */
  const onHPClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    return onHPTriggered();
  };

  //`hide` exists as style, but naming differently to attempt obfuscation from bot
  return (
    <div className="csw-hp">
      <button className="csw-hp-btn" type="submit" onClick={onHPClick} aria-label="Please ignore this" tabIndex={-1}>
        Submit
      </button>
    </div>
  );
};

/** @type {ComponentType<HoneyPotProps>} */
export default connect("", actions)(HoneyPot);
